import React, {Component} from 'react'
import {Button} from "reactstrap"
import StaticsProduceSkusPopup from './StaticsProduceSkusPopup'
import PubSub from "pubsub-js";

class StaticsProduceSkus extends Component {
    state = {
        isOpen: false
    }

    _handleToggleModal = () => {
        const {typeSku} = this.props
        if(this.state.isOpen) {
            if (typeSku === '3D') {
                PubSub.publish('RELOAD_STATICS_3D')
            } else {
                PubSub.publish('RELOAD_STATICS_2D')
            }
        }
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    render() {
        const {isOpen} = this.state
        const {showButtonSelect} = this.props

        return (
            <div className="StaticsProduceSkus">
                <Button color='primary' disabled={!showButtonSelect} onClick={this._handleToggleModal}>Chọn Sku</Button>

                {
                    isOpen &&
                    <StaticsProduceSkusPopup {...this.props} isOpen={isOpen} onToggleModal={this._handleToggleModal}/>
                }
            </div>
        )
    }
}

export default StaticsProduceSkus